import { useAuth } from "@/features/auth/hooks/use-auth-react";
import { AccountSecurityWebauthn } from "../account-security-webauthn/account-security-webauthn.react";

export const AccountSecurityWebauthnForcePage = () => {
  const { refresh } = useAuth();

  return (
    <div className="text flex w-full flex-row justify-center">
      <div className="flex flex-col justify-center text-center">
        <AccountSecurityWebauthn force_webauthn={true} onValidated={() => refresh(true)} />
      </div>
    </div>
  );
};
